import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'
import styles from './SecondaryTab.module.scss'
import { Icon } from 'components/shared/Icon/Icon'

export const SecondaryTab = ({
  id,
  icon,
  label,
  isDisabled,
  isActiveTab,
  setActiveTab,
  tabClassName,
  iconClassName,
}) => {
  return (
    <button
      className={cx(styles.tab, tabClassName, {
        [styles.active]: isActiveTab,
        [styles.disabled]: isDisabled,
      })}
      key={id}
      {...(R.not(isDisabled) && { onClick: () => setActiveTab(id) })}
    >
      {icon ? (
        <Icon className={cx(styles.icon, iconClassName)} icon={icon} />
      ) : null}
      {label}
    </button>
  )
}
